

module.exports = __webpack_require__.stylable.create(
    "ColorOption2205205031",
    {"classes":{"root":"ColorOption2205205031__root","colorOption":"ColorOption2205205031__colorOption"},"vars":{},"stVars":{"colorOptionSelectionBorderColor":"'\"color(color-5)\"'"},"keyframes":{}},
    "",
    19,
    "ColorOption2205205031",
    null
);
